import { img } from './site'

export const steps = [
  {
    title: 'Intake',
    text: 'Samen met u beoordelen we lak en interieur, meten waar nodig en spreken precies af wat uw auto krijgt.',
  },
  {
    title: 'Decontaminatie',
    text: 'Een veilige 2-emmer handwas, chemische decontaminatie en kleibehandeling. Niets wordt gepolijst voordat het écht schoon is.',
  },
  {
    title: 'Correctie',
    text: 'Eén of meerdere polijststappen, afgestemd op de hardheid van uw lak en paneel voor paneel gecontroleerd.',
  },
  {
    title: 'Bescherming',
    text: 'Wax, sealant of een keramische coating, plus een onderhoudsschema zodat het resultaat ook blijft.',
  },
]

export const gallery = [
  { src: img.foam, alt: 'Snow foam over een rode hatchback in de wasbox', span: 'tall' },
  { src: img.beading, alt: 'Water parelt af op een vers gecoate motorkap', span: 'normal' },
  { src: img.after, alt: 'Spiegelglans na een 2-staps polijstbehandeling', span: 'tall' },
  { src: img.wheel, alt: 'Gereinigde velg en band', span: 'normal' },
  { src: img.interior, alt: 'Interieur na stoomreiniging en extractie', span: 'normal' },
  { src: img.wash, alt: 'Handmatig wassen met een washandschoen', span: 'wide' },
  { src: img.studio, alt: 'Binnen in de werkplaats van Daily Car Care', span: 'normal' },
  { src: img.correction, alt: 'Machinaal polijsten van een donkerblauw deurpaneel', span: 'wide' },
]

export const reviews = [
  {
    quote:
      'Mijn Golf zat vol swirls. Na de 2-staps correctie is de lak dieper dan op de dag dat ik hem ophaalde.',
    name: 'Rick van Dijk',
    car: 'VW Golf — Lakcorrectie',
  },
  {
    quote:
      'Op zaterdag online geboekt, binnen een uur bevestiging. Duidelijke afspraken en het resultaat is showroomniveau.',
    name: 'Jeroen Bakker',
    car: 'Opel Astra — Showroom Pakket',
  },
  {
    quote:
      'Het interieur van onze bus zag er hopeloos uit. Met stoom en extractie compleet gered — scheelt een dure stoffering.',
    name: 'Peter Hoogendijk',
    car: 'Ford Transit — Interieur Reiniging',
  },
]

export const faqs = [
  {
    q: 'Werken jullie alleen op afspraak?',
    a: 'Ja. Om alle aandacht op uw voertuig te kunnen richten werken wij uitsluitend op afspraak. Online boeken kan 24/7 en afspraken buiten reguliere tijden zijn in overleg mogelijk.',
  },
  {
    q: 'Hoelang gaat een keramische coating mee?',
    a: 'Afhankelijk van het pakket één tot meerdere jaren. Wij communiceren bewust een realistische standtijd in plaats van onrealistische marketingclaims; periodiek correct onderhoud blijft noodzakelijk.',
  },
  {
    q: 'Mag ik met een coating door de wasstraat?',
    a: 'Dat raden wij ten strengste af. Borstels brengen precies de krassen terug die wij eruit hebben gehaald. Voor coating-klanten hebben wij een aparte onderhoudswas.',
  },
  {
    q: 'Is de prijs die ik online zie definitief?',
    a: 'Het is een vaste richtprijs. Blijkt bij de intake dat uw auto meer — of juist minder — nodig heeft, dan hoort u dat voordat wij beginnen.',
  },
]
